export default __webpack_public_path__ + "static/media/searchWhite.f1a71202.svg";